import PropTypes from 'prop-types';
import React, {Component} from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
//Utils
import events from '../../../../lib/events.js';
import ToolTip, {tooltipPositions} from '../../../components/ToolTip.jsx';
import phoneFormat from '../../../../util/phoneformat.js';
import {problemSelectFields, getProblemModel} from '../../../helpers/problemHelpers.jsx';
import {dateTimeFormats} from 'helpers/constants';

//Components
import Loader from '../../../components/loader.jsx';
import PrintableFullReport from '../components/printableFullReport.jsx';
import ReportDropDown from '../components/reportDropDown.jsx';

//Apis
import ReportApi from '../../../../api/report.jsx';
import FollowUpApi from '../../../../api/followUp.jsx';

import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

import {reportDateFormat} from 'helpers/constants';

const filterOptions = {
  branch: -1,
  branchOptions: [ ],
  poolType: -1,
  poolTypeOptions: [ ],
  tester: '',
  testerOptions: [
    {
      value: '',
      label: 'All',
    },
  ],
  problem: 0,
};

const dateOneMonthAgo = moment().subtract(30, 'days');

class CompletedFollowUps extends Component {
  constructor(props) {
    super(props);
    let {formatMessage} = this.props.intl;
    const _filterOptions = Object.assign({}, filterOptions);
    const branchesFilterable = this.props.branches.map(b => {
      return {
        value: b.id,
        label: b.name,
      };
    });

    _filterOptions.branchOptions = [
      {
        value: -1,
        label: formatMessage({id: 'general.all.stores'}),
      }, ...branchesFilterable];
    const testersFilterable = this.props.testers.map(b => {
      return {
        value: b.name,
        label: b.name,
      };
    });

    _filterOptions.poolTypeOptions =  [
      {
        value: -1,
        label: formatMessage({id: 'general.all.systems'}),
      },
      {
        value: 1,
        label: formatMessage({id: 'general.pools'}),
      },
      {
        value: 2,
        label: formatMessage({id: 'general.spas'}),
      },
      {
        value: 3,
        label: formatMessage({id: 'general.swim.spas'}),
      },
    ];

    _filterOptions.testerOptions = [
      {
        value: '',
        label: formatMessage({id: 'general.all'}),
      }, ...testersFilterable];

    const problemOptions = problemSelectFields.map(p => {
      return {
        value: p.id,
        label: formatMessage({id: p.name}),
      };
    });

    _filterOptions.problemOptions = problemOptions;
    this.state = {
      loaded: true,
      summary: null,
      report: null,
      start: dateOneMonthAgo,
      end: moment(),
      startLabel: dateOneMonthAgo,
      endLabel: moment(),
      branches: this.props.branches.map(b => b.id),
      showNoDataMessage: false,
      ..._filterOptions,
    };
  }

  componentWillUnmount() {
    this.setState({
      filterOptions: {},
    });
  }

  changeRevertClass(event) {
    event.target.classList.toggle('bl-revert');
    event.target.classList.toggle('bl-revert-over');
  }

  clickedDismiss(id) {
    FollowUpApi.dismiss(id)
      .then(() => {
        this.state.report.find(x => x.ID === id)['Dismissed'] = moment.utc().format(dateTimeFormats.numeralDate);
        this.setState({report: this.state.report});
      })
      .catch(error => events.publish('error.user', error));
  }

  clickedFollowUp(id) {
    FollowUpApi.followUp(id)
      .then(() => {
        this.state.report.find(x => x.ID === id)['FollowedUp'] = moment.utc().format('M/DD/YYYY');
        this.setState({report: this.state.report});
      })
      .catch(error => events.publish('error.user', error));
  }
  clickedRevert(id) {
    FollowUpApi.revert(id)
      .then(() => {
        let report = this.state.report.find(x => x.ID === id);

        report['FollowedUp'] = '';
        report['Dismissed'] = '';
        this.setState({report: this.state.report});
      })
      .catch(error => events.publish('error.user', error));
  }

  detailedView() {
    let {formatMessage} = this.props.intl;
    const reports = this.state.report;

    return (
      <table className='table-biolab table-striped follow-up-table'>
        <thead style={{fontSize: '13px'}}>
          <tr>
            <th style={{width: '100px'}}><FormattedMessage id='general.primary.contact' /></th>
            <th><FormattedMessage id='general.primary.phone' /></th>
            <th style={{width: '130px'}}><FormattedMessage id='general.email.address' /></th>
            <th><FormattedMessage id='general.last.analysis' /></th>
            <th><FormattedMessage id='general.next.analysis' /></th>
            <th><FormattedMessage id='general.water.tester' /></th>
            <th style={{width: '120px', paddingTop: '10px'}}>
              <FormattedMessage id='general.system' /><br/><FormattedMessage id='general.email' />
              <ToolTip title={formatMessage({id: 'general.email.status.tooltip'})}
                        position={tooltipPositions.topRight} iconOnly invert />
            </th>
            <th style={{width: '150px'}}>
              <FormattedMessage id='general.followup' /><br/><FormattedMessage id='general.status' />
              <ToolTip body={<p><FormattedMessage id='general.followup.tooltip.one' /> <i className='bl bl-follow-up'/>
                <FormattedMessage id='general.followup.tooltip.five' /></p>}
                         position={tooltipPositions.topRight} iconOnly invert />
            </th>
          </tr>
        </thead>
        <tbody>
          {
            reports.map(row => {
              let customerLink = `#customer/${row.CustomerID}`;

              return (
                <tr key={row.ID}>
                  <td>
                    <a href={customerLink}>{row.FullName}</a>
                  </td>
                  <td>{row.HomePhone}</td>
                  <td>{row.Email ? row.Email : '-'}</td>
                  <td>{moment(row.Created).format(dateTimeFormats.numeralDate)}</td>
                  <td>{moment(row.NextAnalysisDate).format(dateTimeFormats.numeralDate)}</td>
                  <td>{row.Tester}</td>
                  <td>
                    {this.emailColumn(row, formatMessage)}
                  </td>
                  <td style={{paddingRight: '10px'}}>
                    <span className='follow-up-summary'><i className='bl bl-called'/> {row['FollowedUp']} </span>
                  </td>
                </tr>
              );
            })
          }
        </tbody>
      </table>
    );
  }

  emailColumn(report, formatMessage) {
    let FollowUpDate = report['FollowUpDate'] ? moment.utc(report['FollowUpDate']) : '';

    if (!report.Email || report.Email.trim() === '') {
      return <div><i className='bl bl-attention red'/> {formatMessage({id: 'general.no.email'})}</div>;
    }
    if (!FollowUpDate || FollowUpDate.isAfter(moment.utc())) {
      return <div><i className='bl bl-attention red'/> {formatMessage({id: 'general.email.not.sent'})}</div>;
    }
    if (!report['Emailed'] && FollowUpDate.isBefore(moment.utc())) {
      return <div><i className='bl bl-opted-out'/> {formatMessage({id: 'general.email.opted.out'})}</div>;
    }
    return <div>{FollowUpDate.format('M/DD/YYYY')}</div>;
  }

  exportReport = () => {
    const {start, end, branch, poolType, branches, tester, problem} = this.state;

    ReportApi.getFollowUpReportExport(
      this.props.intl.locale,
      branch === -1 ? branches : branch,
      start.format(), end.format(),
      poolType === -1 ? null : poolType, getProblemModel({problem: problem}), tester, true);
  };

  printReport = () => {
    let {formatMessage} = this.props.intl;
    const {report, start, end, summary} = this.state;
    const tableColumns = [
      {name: formatMessage({id: 'general.primary.contact'}), key: 'FullName'},
      {name: formatMessage({id: 'general.primary.phone'}), key: 'HomePhone'} ,
      {name: formatMessage({id: 'general.email.address'}), key: 'Email'},
      {name: formatMessage({id: 'general.last.analysis'}), key: 'Created'},
      {name: formatMessage({id: 'general.next.analysis'}), key: 'NextAnalysisDate'},
      {name: formatMessage({id: 'general.water.tester'}), key: 'Tester'},
      {name: formatMessage({id: 'general.system.email'}), key: 'SystemEmail'},
      {name: formatMessage({id: 'general.followup'}), key: 'FollowedUp'},
    ];
    const summaryColumns = [
      {name: formatMessage({id: 'general.total.accounts'}), key: 'total'},
      {name: formatMessage({id: 'reports.followups.completed.followups'}), key: 'complete'},
      {name: formatMessage({id: 'general.water.clarity'}), key: 'water'},
      {name: formatMessage({id: 'general.algae'}), key: 'algae'},
      {name: formatMessage({id: 'general.surface.problems'}), key: 'surface'},
      {name: formatMessage({id: 'general.chlorine.demand'}), key: 'chlorine'},
      {name: formatMessage({id: 'general.total.maintenance'}), key: 'maintenanceSystems'},
    ];

    report.forEach((element) => {
      element.SystemEmail = this.emailColumn(element, formatMessage);
    }, this);

    return (
      <PrintableFullReport
        end={end.format(dateTimeFormats.numeralDate)}
        endLabel={formatMessage({id: 'general.end.date'})}
        formatMessage={formatMessage}
        start={start.format(dateTimeFormats.numeralDate)}
        startLabel={formatMessage({id: 'general.start.date'})}
        summaryColumns={summaryColumns}
        summaryData={summary}
        tableColumns={tableColumns}
        tableData={report}
        title={formatMessage({id: 'reports.followups.completed.followups'})}
      />
    );
  };

  resetFilters = () => {
    this.setState({
      branch: -1,
      customerType: '',
      end: moment(),
      poolType: -1,
      problem: 0,
      start: dateOneMonthAgo,
      startLabel: dateOneMonthAgo,
      endLabel: moment(),
      tester: '',
    });
  };

  stateSetter(propName) {
    return value => this.setState({[propName]: value});
  }

  updateReport = () => {
    const {branch, start, end, poolType, branches, tester, problem} = this.state;

    this.setState({
      loaded: false,
      summary: null,
    });
    const conditionalPush = (condition, list, pushValue) => {
      if (condition) {
        list.push(pushValue);
      }
    };

    ReportApi.getFollowUpReport(
      branch === -1 ? branches : branch,
      start.format(), end.format(),
      poolType === -1 ? null : poolType, getProblemModel({problem: problem}), tester, true)
      .then(data => {
        if (data.report) {
          for (let row of data.report) {
            row.FullName = row.NameFirst + ' ' + row.NameLast;
            let problems = [];
            //Created string list of all problems of follow-up

            conditionalPush(row.Cloudy, problems, 'Cloudy');
            conditionalPush(row.Hazy, problems, 'Hazy');
            conditionalPush(row.Foaming, problems, 'Foaming');
            conditionalPush(row.BlackAlgae, problems, 'Black Algae');
            conditionalPush(row.GreenAlgae, problems, 'Green Algae');
            conditionalPush(row.MustardAlgae, problems, 'Mustard Algae');
            conditionalPush(row.SpaAlgae, problems, 'Algae');
            conditionalPush(row.SlimeMold, problems, 'Slime/Mold');
            conditionalPush(row.Swampy, problems, 'Swampy');
            conditionalPush(row.CopperStaining, problems, 'Copper Staining');
            conditionalPush(row.IronStaining, problems, 'Iron Staining');
            conditionalPush(row.UnknownStaining, problems, 'Unknown Staining');
            conditionalPush(row.ScaleBuildup, problems, 'Scale Buildup');
            conditionalPush(row.WaterlineBuildup, problems, 'Waterline Buildup');
            conditionalPush(row.OrganicStaining, problems, 'Organic Staining');
            conditionalPush(row.ChlorineDemand, problems, 'Chlorine Demand');
            row.Problems = problems.join(', ');
            row.HomePhone = row.HomePhone ? phoneFormat(row.HomePhone) : '';
            row.FollowedUp = row.FollowedUp ? moment.utc(row.FollowedUp).format('M/DD/YYYY') : '';
            row.Dismissed = row.Dismissed ? moment.utc(row.Dismissed).format('M/DD/YYYY') : '';
            row.Created = row.Created ? moment.utc(row.Created).format('M/DD/YYYY') : '';

            let FollowUpDate = row['FollowUpDate'] ? moment.utc(row['FollowUpDate']) : '';

            if (!row.Email || row.Email.trim() === '') {
              row.EmailString = 'No Email';
            }
            if (!FollowUpDate || FollowUpDate.isAfter(moment.utc())) {
              row.EmailString = 'Email Not Sent';
            }
            if (!row['Emailed'] && FollowUpDate.isBefore(moment.utc())) {
              row.EmailString = 'Opted Out';
            }
            if (row.FollowUpDate) {
              row.EmailString = moment(row.FollowUpDate).format('M/DD/YYYY');
            }
            if (row.NextAnalysisDate) {
              row.NextAnalysisDate = moment(row.NextAnalysisDate).format('MM/DD/YYYY');
            }
            if (row.Created) {
              row.Created = moment(row.Created).format('MM/DD/YYYY');
            }
          }
        }
        if(data && data.summary.total > 0) {
          this.setState({summary: data.summary, report: data.report, startLabel: start, endLabel: end, showNoDataMessage: false});
        } else {
          this.setState({showNoDataMessage: true});
        }
        this.setState({loaded: true});
      }).catch(err => {
        console.log(err);
        this.setState({showNoDataMessage: true});
      }).complete(() => {
        this.setState({
          loaded: true,
        });
      });
  };

  render() {
    let {formatMessage} = this.props.intl;
    const {start, end, problem, problemOptions, summary, loaded, tester, testerOptions, branch, branchOptions, poolType, poolTypeOptions, report, startLabel, endLabel, showNoDataMessage} = this.state;

    return (
      <div className='report-container'>
        <span className='description'><FormattedMessage id='reports.complete.followup.description' /></span>
        <div className='report-options'>
          <div className='top-title-bar'>
            <FormattedMessage id='general.report.options' />
          </div>
          <div className='select-options container-fluid'>
            <div className='row'>
              <div className='col-sm-3'>
                <div className='form-group'>
                  <label><FormattedMessage id='general.date.from' /></label>
                  <div className='editable-datepicker'>
                    <DatePicker selected={start} dateFormat={reportDateFormat}
                      maxDate={end.clone().subtract(1, 'days')}
                      onChange={((e) => {
                        this.setState({start: e});
                      })}/>
                  </div>
                </div>
              </div>
              <div className='col-sm-3'>
                <div className='form-group'>
                  <label><FormattedMessage id='general.date.to' /></label>
                  <div className='editable-datepicker'>
                    <DatePicker selected={end} dateFormat={reportDateFormat}
                      minDate={moment(start).clone()}
                      maxDate={moment()}
                      onChange={((e) => {
                        this.setState({end: e});
                      })}/>
                  </div>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-sm-3'>
                <ReportDropDown value={branch} label={formatMessage({id: 'general.store'})}
                  onChange={((e) => {
                    this.setState({branch: parseInt(e.target.value)});
                  })}
                  options={branchOptions} />
              </div>
              <div className='col-sm-3'>
                <ReportDropDown value={poolType} label={formatMessage({id: 'general.system.type'})}
                  onChange={((e) => {
                    this.setState({poolType: parseInt(e.target.value)});
                  })}
                  options={poolTypeOptions} />
              </div>
              <div className='col-sm-3'>
                <ReportDropDown value={problem} label={formatMessage({id: 'general.problem'})}
                  onChange={((e) => {
                    this.setState({problem: e.target.value});
                  })}
                  options={problemOptions} />
              </div>
              <div className='col-sm-3'>
                <ReportDropDown value={tester} label={formatMessage({id: 'general.water.tester'})}
                  onChange={((e) => {
                    this.setState({tester: e.target.value});
                  })}
                  options={testerOptions} />
              </div>
            </div>
          </div>
          <div className='manage-options'>
            <div className='col-sm-12 button-group'>
              <span className='reset-button pull-right' onClick={this.resetFilters}><FormattedMessage id='general.reset' /></span>
              <button className='btn btn-primary pull-right' onClick={this.updateReport}><FormattedMessage id='reports.update.summary' /></button>
            </div>
          </div>
        </div>
        <Loader loaded={loaded}>
          {summary ?
            <div className='col-sm-12 summary-container'>
              <div className='row'>
                <h2>
                  <FormattedMessage id='reports.report.summary' />
                  <span className='summary-date'> | <FormattedMessage id='general.date.range.labelled' values={{
                    start: startLabel.format(dateTimeFormats.numeralDate),
                    end: endLabel.format(dateTimeFormats.numeralDate),
                  }} />
                  </span>
                </h2>
                <p className='description'><FormattedMessage id='reports.reveal.report.summary' /></p>
              </div>
              <div className='row'>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id='general.total.accounts' /></label>
                  <div>{summary.total}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id='reports.followups.completed.followups' /></label>
                  <div>{summary.complete}</div>
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id='general.water.clarity' /></label>
                  <div>{summary.water}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id='general.algae' /></label>
                  <div>{summary.algae}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id='general.surface.problems' /></label>
                  <div>{summary.surface}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id='general.chlorine.demand' /></label>
                  <div>{summary.chlorine}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id='general.total.maintenance' /></label>
                  <div>{summary.maintenanceSystems}</div>
                </div>
              </div>
              <div className='pad-top'>
                { report ? this.detailedView() : <div />}
              </div>
            </div> :
            <div className='summary-container'>
              <h2><FormattedMessage id='reports.report.summary' /></h2>
              <p><FormattedMessage id='reports.reveal.report.summary' /></p>
              {showNoDataMessage ? <label className='report-no-data'><FormattedMessage id='reports.error.no.results' /></label> : ''}
              <div className='container-fluid custom-container-margins'><div /></div>
            </div>}
          <div className='col-sm-12 button-group shift-right'>
            <button className='btn btn-default pull-right' disabled={(summary === null)} onClick={(() => {
              events.publish('print', this.printReport());
            })}><FormattedMessage id='reports.print.summary' /></button>
            <button className='btn btn-primary pull-right' onClick={this.exportReport}><FormattedMessage id='reports.export.report' /></button>
          </div>
        </Loader>
      </div>
    );
  }
}

CompletedFollowUps.propTypes = {
  POSActive: PropTypes.bool,
  branches: PropTypes.any,
  intl: intlShape.isRequired,
  testers: PropTypes.any,
};

CompletedFollowUps.defaultProps = {
  branches: [],
  POSActive: false,
};

export default injectIntl(CompletedFollowUps);
